import React, {useEffect, useState} from "react";
import style from "./DiceComponent.module.css";
import ManualDice from "../../components/ManualDice";
import * as GroupGameService from "../../api/GroupGameService";
import RollingDiceComponent from "../../components/RollingDiceComponent";
import {deepPurple} from "@mui/material/colors";
import HeightIcon from "@mui/icons-material/Height";
import AutoModeOutlinedIcon from '@mui/icons-material/AutoModeOutlined';
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import OpenWithOutlinedIcon from "@mui/icons-material/OpenWithOutlined";

export default function DiceComponent(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'diceComponent' });

    const [lastDice, setLastDice] = useState(1)

    function rollDice(number) {
        GroupGameService.postDiceMove(props.game_id, props.selectedPlayer?.id, number, () => {}, () => {})
    }

    function flipDiceDirection () {
        props.setDiceHorizontal(!props.isDiceHorizontal)
    }

    useEffect(() => {
        try {
            if (props.selectedPlayer && props.selectedPlayer.steps.length > 0 ) {
                let ld = 1
                if (props.selectedPlayer.steps[0].player_move_type === "hand_move") {
                    if (props.selectedPlayer.steps[1]) {
                        ld = props.selectedPlayer.steps[1] // there might be metaphoric card
                    } else {
                        setLastDice(1)
                    }

                } else {
                    ld = props.selectedPlayer.steps[0].dice_number || 1 // there might be metaphoric card
                }

                setLastDice(ld)
            } else {
                setLastDice(1)
            }
        } catch (e) {
            console.error("GG last dice error", e)
            setLastDice(1)
        }

    }, [props.selectedPlayer])

    return (
        <div style={{position: "absolute", zIndex: 1550, touchAction: "none"}}>
            {(props.selectedPlayer?.is_auto_dice || false) &&
                <div className={style.autoDice}>
                    <div className={style.moveControl}>
                        <OverlayTrigger
                            placement="top"
                            delay={{show: 400, hide: 50}}
                            overlay={<Tooltip id="button-tooltip">{t('change dice type')}</Tooltip>}
                        >
                            <AutoModeOutlinedIcon
                                sx={{ color: deepPurple[50], cursor: "pointer"}}
                                onClick={() => GroupGameService.changeDiceType(props.game_id, props.selectedPlayer.id, ()=>{}, ()=>{})}
                            />
                        </OverlayTrigger>
                        <OpenWithOutlinedIcon sx={{ color: deepPurple[50] }} className="handle"/>
                    </div>

                    <RollingDiceComponent sendDiceValue={rollDice} dice_num={lastDice}/>
                </div>
            }
            {(!props.selectedPlayer?.is_auto_dice || false) &&
                <div className={props.isDiceHorizontal? style.manualDice: style.manualDiceVertical}>
                    <div className={style.moveControl}>
                        <OverlayTrigger
                            placement="top"
                            delay={{show: 400, hide: 50}}
                            overlay={<Tooltip id="button-tooltip">{t('change dice type')}</Tooltip>}
                        >
                            <AutoModeOutlinedIcon
                                sx={{ color: deepPurple[50], cursor: "pointer"}}
                                onClick={() => GroupGameService.changeDiceType(props.game_id, props.selectedPlayer.id, ()=>{}, ()=>{})}
                            />
                        </OverlayTrigger>
                        <HeightIcon sx={{ color: deepPurple[50], cursor:"pointer"}} onClick={flipDiceDirection} className={props.isDiceHorizontal ? style.flipped0 : style.flipped90}/>
                        <OpenWithOutlinedIcon sx={{ color: deepPurple[50] }} className="handle"/>
                    </div>
                    <ManualDice setDiceValue={rollDice} isHorizontal={props.isDiceHorizontal}/>
                </div>
            }
        </div>
    )
}